import React from 'react';
import { MessageCircle } from 'lucide-react';
import { companyInfo, navigationLinks } from '../data/mock';

const Footer = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black border-t border-white/10">
      <div className="container mx-auto px-6 md:px-10">
        {/* Main Footer */}
        <div className="py-16 md:py-20">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
            {/* Brand */}
            <div className="lg:col-span-2">
              <div className="flex items-center gap-3 mb-6">
                <img
                  src={companyInfo.logo}
                  alt={companyInfo.name}
                  className="h-16 w-auto invert"
                />
                <span className="text-white font-bold text-2xl tracking-tight">
                  {companyInfo.name}
                </span>
              </div>
              <p className="text-gray-500 max-w-md leading-relaxed mb-6">
                Ezine, Üvecik'te kurulu profesyonel besi çiftliğimizle, et işleme tesislerine ve kesimhanelere güvenilir ve kaliteli sığır eti tedarik ediyoruz.
              </p>
              <p className="text-white font-semibold mb-6">
                {companyInfo.tagline}
              </p>
              
              {/* WhatsApp Button */}
              <a
                href={companyInfo.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-green-500 text-white px-6 py-3 font-semibold uppercase tracking-wide text-sm hover:bg-green-600 transition-colors"
              >
                <MessageCircle className="w-5 h-5" />
                WhatsApp ile Ulaşın
              </a>
            </div>

            {/* Navigation */}
            <div>
              <h4 className="text-white font-bold uppercase tracking-wider mb-6">
                Sayfalar
              </h4>
              <nav className="space-y-3">
                {navigationLinks.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(link.href);
                    }}
                    className="block text-gray-500 hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                ))}
              </nav>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-white font-bold uppercase tracking-wider mb-6">
                İletişim
              </h4>
              <div className="space-y-3 text-gray-500 text-sm">
                <p>Üvecik Köyü</p>
                <p>Ezine, Çanakkale</p>
                <p>Türkiye</p>
                <p className="pt-3">
                  <a 
                    href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
                    className="hover:text-white transition-colors"
                  >
                    {companyInfo.phone}
                  </a>
                </p>
                <p>
                  <a 
                    href={`mailto:${companyInfo.email}`}
                    className="hover:text-white transition-colors"
                  >
                    {companyInfo.email}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-600 text-sm">
              © {new Date().getFullYear()} {companyInfo.name}. Tüm hakları saklıdır.
            </p>
            <p className="text-gray-600 text-sm">
              B2B Et Tedarikçisi | Ezine, Türkiye
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
